import React, { Component } from "react";
import { Chart, Geom, Axis, Coord, Tooltip } from "bizcharts";

class KeywordPositionChart extends Component {
  getYAxisMin = chartData => {
    const min = chartData.reduce((min, item) => (item.pos < min ? item.pos : min), this.props.chartData[0].pos);

    if (chartData.length > 1) {
      return min - 5 > 0 ? min - 5 : min;
    }

    return 1;
  };

  getYAxisMax = chartData => {
    const max = chartData.reduce((max, item) => (item.pos > max ? item.pos : max), this.props.chartData[0].pos);

    if (chartData.length > 1) {
      return max + 5 >= 100 ? 100 : max + 5;
    }

    return 100;
  };

  tooltipRender = (c_at, pos) => {
    return {
      name: "Position",
      value: pos <= 100 ? pos : "> 100"
    };
  };
  render() {
    let scale = null;

    if (this.props.chartData && this.props.chartData.length) {
      scale = {
        pos: {
          type: "linear",
          min: this.getYAxisMin(this.props.chartData),
          max: this.getYAxisMax(this.props.chartData),
          formatter: pos => (pos === 0 ? 1 : pos)
        },
        c_at: {
          type: "timeCat",
          mask: "MMM DD",
          nice: true
        }
      };
    }

    return (
      <div className="tracked-keywords-chart-container">
        <Chart
          padding="auto"
          height={this.props.height}
          data={this.props.chartData}
          scale={scale}
          forceFit
          animate={false}>
          <Axis name="c_at" position="top" />
          <Axis name="pos" />
          <Tooltip />
          <Coord reflect="y" />
          <Geom type="line" position="c_at*pos" size={2} tooltip={["c_at*pos", this.tooltipRender]} />
          <Geom
            type="point"
            position="c_at*pos"
            tooltip={["c_at*pos", this.tooltipRender]}
            size={4}
            shape={"circle"}
            style={{ stroke: "#fff", lineWidth: 1 }}
          />
        </Chart>
      </div>
    );
  }
}

export default KeywordPositionChart;
